(function () {
	const initSlider = () => {
		document.querySelectorAll(".product-card-js").forEach(function(container) {
			if (container.classList.contains("slider_started")) return;
			container.classList.add("slider_started");

			var swiper = new Swiper(container, {
				slidesPerView: 1,
				speed: 250,
				spaceBetween: 0,
				navigation: {
					nextEl: container.querySelector(".swiper-button-next-1"),
					prevEl: container.querySelector(".swiper-button-prev-1"),
				},
				pagination: {
					el: container.querySelector(".product-card-pagination"),
					clickable: true,
				},
				on: {
					init: function(swiper) {
						updateButtons(swiper, container);
					},
					slideChange: function(swiper) {
						updateButtons(swiper, container);
					}
				}
			});
		});
	};

	function updateButtons(swiper, container) {
		const prevGroup = container.closest('.product-card').querySelector('.button-prev');
		const nextGroup = container.closest('.product-card').querySelector('.button-next');
		
		if (prevGroup) {
			prevGroup.style.visibility = swiper.isBeginning ? 'hidden' : 'visible';
		}
		if (nextGroup) {
			nextGroup.style.visibility = swiper.isEnd ? 'hidden' : 'visible';
		}
	}

	initSlider();
	document.addEventListener("shopify:section:load", function () {
		initSlider();
	});
})();